export default {
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setLesson(state, lesson) {
    state.lesson = lesson;
  },
  setCount(state, count) {
    state.count = count;
  },
  setFavorites(state, favorites) {
    state.favorites = favorites;
  }
};
